"use client";

import { useEffect } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

// Global error boundary. Prevents an unhandled render error anywhere in the app
// (such as a production module-init TDZ) from white-screening the whole site.
// `error.tsx` at_the_app_root_still_renders_inside_the_root_layout, so no
// <html>/<body> wrapper is required here.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global app_error:", error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground p-6">
      <div className="matte-metal max-w-md w-full p-8 rounded-3xl border border-border text-center space-y-5">
        <div className="mx-auto w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center border border-red-500/30">
          <AlertTriangle className="w-8 h-8 text-red-400" />
        </div>
        <div className="space-y-2">
          <h2 className="display text-2xl uppercase tracking-tight text-foreground font-black">
            Something Broke
          </h2>
          <p className="text-xs text-muted-foreground font-medium leading-relaxed">
            An unexpected error occurred. Retry to recover — your session and
            data are safe.
          </p>
        </div>
        <button
          type="button"
          onClick={reset}
          className="w-full flex items-center justify-center gap-2 bg-y text-black font-black text-xs uppercase tracking-[0.2em] py-4 rounded-xl transition-all hover:opacity-90 hover:scale-[1.01] active:scale-[0.98]"
        >
          <RotateCcw size={16} /> Retry
        </button>
      </div>
    </div>
  );
}
